<div *ngIf="showLoader" class="overlay">
  <!-- <img src="{{imageSrc}}/assets/loader.png" width="100" /> -->
  <mat-spinner></mat-spinner>
  <p class="loading-text" *ngIf="msg">&nbsp; Downloading is in progress. Please wait.</p>
</div>
